export default "__VITE_ASSET__DdweE1R8__"